/**
 * Toggle that flips a player's handicap index sign. Plus handicaps (better
 * than scratch) are stored as negative numbers; this control lets users pick
 * the sign without typing "+" on a numeric keyboard.
 *
 * Two visual variants:
 * - default — pill always labelled "+ Plus", muted when off / accent-filled when on
 * - compact — small icon-only "+" button for inline editors next to a tiny number input
 */
export default function PlusHandicapToggle({ isPlus, onChange, compact = false, disabled = false }) {
  const handleClick = () => {
    if (disabled) return
    onChange(!isPlus)
  }

  if (compact) {
    return (
      <button
        type="button"
        onClick={handleClick}
        onMouseDown={(e) => e.preventDefault()}
        disabled={disabled}
        aria-pressed={isPlus}
        aria-label={isPlus ? 'Plus handicap (tap to switch to regular)' : 'Regular handicap (tap to switch to plus)'}
        style={{
          width: '28px',
          height: '28px',
          padding: 0,
          borderRadius: '0.25rem',
          fontSize: '0.875rem',
          fontWeight: 700,
          lineHeight: 1,
          flexShrink: 0,
          cursor: disabled ? 'default' : 'pointer',
          backgroundColor: isPlus ? 'var(--accent-primary)' : 'var(--bg-secondary)',
          border: `1px solid ${isPlus ? 'var(--accent-primary)' : 'var(--border-color)'}`,
          color: isPlus ? '#fff' : 'var(--text-muted)',
        }}
      >
        +
      </button>
    )
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      aria-pressed={isPlus}
      aria-label={isPlus ? 'Plus handicap (tap to switch to regular)' : 'Regular handicap (tap to switch to plus)'}
      style={{
        height: '40px',
        padding: '0 0.875rem',
        borderRadius: '0.375rem',
        fontSize: '0.8125rem',
        fontWeight: 600,
        flexShrink: 0,
        cursor: disabled ? 'default' : 'pointer',
        backgroundColor: isPlus ? 'var(--accent-primary)' : 'var(--bg-secondary)',
        border: `1px solid ${isPlus ? 'var(--accent-primary)' : 'var(--border-color)'}`,
        color: isPlus ? '#fff' : 'var(--text-muted)',
        whiteSpace: 'nowrap',
      }}
    >
      + Plus
    </button>
  )
}
